<template>
  <div class="sw-panel">
    <div v-if="loading" class="sw-loading">
      <van-loading type="spinner" color="#7b4dff" />
    </div>

    <template v-else-if="selectedChannel">
      <!-- 渠道卡片 -->
      <div class="sw-channel-card">
        <img
          class="sw-channel-logo"
          :src="channelLogo"
          alt=""
        />
        <div class="sw-channel-info">
          <p class="sw-channel-name">{{ selectedChannel.name }}</p>
          <!-- 隐藏手续费 -->
          <!-- <p v-if="channelFeeText" class="sw-channel-fee">
            {{ $t("guild_reference_fee") }}: {{ channelFeeText }}
          </p> -->
        </div>
        <button type="button" class="sw-change-btn" @click="showChannelPicker = true">
          {{ $t("guild_change_channel") }}
        </button>
      </div>
      <div class="sw-balance-parent">
        <!-- 可提现余额 -->
        <div class="sw-balance">
          <span>{{ $t("guild_current_can_withdraw") }}</span>
          <span class="sw-balance-num">{{ coinText }}</span>
        </div>

        <!-- SKU 档位 -->
        <p class="sw-section-title">{{ $t("guild_select_withdraw_amount") }}</p>
        <div class="sw-sku-grid">
          <template v-for="Aitem in skuList">
            <div
              v-if="Aitem.id != 0"
              :key="'sku-' + Aitem.id"
              class="sw-sku-item"
              @click="onSkuClick(Aitem)"
            >
              <div class="sw-sku-fiat">{{ Aitem.cc }} {{ Aitem.num }}</div>
              <div class="sw-sku-coin">
                <img :src="skuCoinIcon" alt="" />
                <span>{{ Aitem.usd.toLocaleString('en-US') }}</span>
              </div>
            </div>
          </template>
          <div
            v-if="selectedChannel.freeAmountEnabled && customSkuItem"
            class="sw-sku-item sw-sku-custom"
            @click="openCustomAmount"
          >
            {{ $t("withdraw_input_amount") }}
          </div>
        </div>
      </div>
      
    </template>

    <!-- 余额不足 -->
    <van-popup v-model="showBalanceTip" round class="sw-balance-popup">
      {{ $t("withdrawalLogin.Pocket") }}
    </van-popup>

    <!-- 更换渠道 -->
    <transition name="sw-picker">
      <div
        v-if="showChannelPicker"
        class="sw-channel-picker-mask"
        @click.self="showChannelPicker = false"
      >
        <div class="sw-channel-sheet" @click.stop>
          <div class="sw-sheet-header">
            <p class="sw-sheet-title">{{ $t("guild_change_channel_title") }}</p>
            <img
              class="sw-sheet-close"
              src="../../assets/withdrawal_v2/close.png"
              alt=""
              @click="showChannelPicker = false"
            />
          </div>
          <div class="sw-channel-list hide-scrollbar" ref="channelList">
            <div
              v-for="item in channelList"
              :key="item.id"
              class="sw-channel-option"
              :class="{ active: item.id === selectedChannelId }"
              @click="selectChannel(item)"
            >
              <div class="sw-channel-option-logo-wrap">
                <img class="sw-channel-option-logo" :src="getChannelLogo(item)" alt="" />
              </div>
              <div class="sw-channel-option-info">
                <div class="sw-channel-option-name">
                  <span>{{ item.name }}</span>
                  <img
                    class="sw-edit-icon"
                    src="../../assets/withdrawal_v2/edit.png"
                    alt=""
                    @click.stop="openChannelEdit(item)"
                  />
                </div>
                <!-- 隐藏手续费 -->
                <!-- <span v-if="getChannelFeeText(item)" class="sw-channel-option-fee">
                  {{ $t("guild_reference_fee") }}: {{ getChannelFeeText(item) }}
                </span> -->
              </div>
              <img
                class="sw-radio-icon"
                :src="
                  item.id === selectedChannelId
                    ? require('../../assets/withdrawal_v2/selected.png')
                    : require('../../assets/withdrawal_v2/select.png')
                "
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </transition>

    <channel-bind-sheet
      :visible="showBindSheet"
      :channel-name="bindChannelName"
      :details-obj="bindDetailsObj"
      :item-id="bindItemId"
      :sabank-list="bindSabankList"
      :token="token"
      :uid="uid"
      :device-id="deviceId"
      :lang="lang"
      @close="closeBindSheet"
      @bound="onBindComplete"
    />

    <!-- 自定义金额弹窗 -->
    <div v-if="showPop" class="sw-mask sw-mask-center" @click="closePopup">
      <div class="sw-amount-dialog" :class="{ 'keyboard-active': keyboardShow }" @click.stop>
        <span class="sw-dialog-close" @click="closePopup"></span>
        <h3 class="sw-dialog-title">{{ $t("withdraw_input_amount") }}</h3>
        <div class="sw-input-row" @click="inputFocus">
          <div class="sw-input-left">
            <img src="../../assets/withdrawal_v2/$.png" alt="" />
            <span ref="measureRef" class="sw-measure" aria-hidden="true">{{ inputValue }}</span>
            <input
              ref="inputRef"
              v-model="inputValue"
              type="text"
              inputmode="numeric"
              class="sw-input"
              @input="changeCoin"
              @click.stop="inputFocus"
              @blur="handleBlur"
            />
          </div>
          <span v-if="fiatHintText" class="sw-fiat-hint">{{ fiatHintText }}</span>
        </div>
        <p class="sw-balance-hint">
          {{ $t("guild_current_can_withdraw") }}
          <img src="../../assets/withdrawal_v2/$.png" alt="" />
          <span>{{ coinText }}</span>
        </p>
        <ul class="sw-gear-box">
          <li :class="{ active: gearType === 0 }" @click="changeGearType(0)">{{ $t("guild_all") }}</li>
          <li :class="{ active: gearType === 1 }" @click="changeGearType(1)">1/2</li>
          <li :class="{ active: gearType === 2 }" @click="changeGearType(2)">1/3</li>
          <li :class="{ active: gearType === 3 }" @click="changeGearType(3)">1/4</li>
        </ul>
        <p v-if="errorAcual === 1" class="sw-error-tip">{{ $t("withdraw_error_min_amount") }}</p>
        <p v-else-if="errorAcual === 2" class="sw-error-tip">{{ $t("withdraw_error_max_amount") }}</p>
        <p v-else-if="errorAcual === 3" class="sw-error-tip">{{ $t("withdraw_error_max_p_coin") }}</p>
        <button
          type="button"
          class="sw-submit-btn"
          :class="{ disabled: !canSubmitCustom }"
          @click="submitPay"
        >
          {{ $t("withdraw_submit") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 自提现 v2 主面板（2026-06-08）
 *
 * 提现流程见 mixins/selfWithdrawFlow.js，所有渠道统一 proceedWithdraw，
 * 不再区分 channelBtn / channelPixBtn 跳转旧页。
 */
import axios from "axios";
import { Toast, Popup, Loading } from "vant";
import "vant/lib/popup/style";
import "vant/lib/loading/style";
import ChannelBindSheet from "@/components/withdrawal/channel-bind-sheet.vue";
import selfWithdrawFlow from "@/mixins/selfWithdrawFlow.js";
import { PIX_CHANNEL_IDS } from "@/utils/withdrawChannel";

const CHANNEL_STORAGE_KEY = "self_withdrawal_channel_id";
/** 标准提现渠道（含印尼），不含 PIX 9/10 */
const STANDARD_CHANNEL_IDS = [5, 8, 7, 4, 11, 6, 13, 12, 15, 16, 17, 18, 19, 20, 21, 22];

export default {
  name: "self-withdrawal-panel",
  mixins: [selfWithdrawFlow],
  components: {
    VanPopup: Popup,
    [Loading.name]: Loading,
    ChannelBindSheet,
  },
  props: {
    parentCoin: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: true,
      listData: {},
      channelList: [],
      selectedChannelId: null,
      showChannelPicker: false,
      showBalanceTip: false,
      token: "",
      uid: "",
      lang: "",
      deviceId: "",
      coin: 0,
      showPop: false,
      inputValue: "",
      gearType: 5,
      acualNum: 0,
      currency: "",
      customizeItem: {},
      customizeAitem: {},
      payType: 1,
      errorAcual: 0,
      keyboardShow: false,
      debounceTimer: null,
    };
  },
  computed: {
    // 当前选中的渠道对象
    selectedChannel() {
      return this.channelList.find((i) => i.id === this.selectedChannelId) || null;
    },
    // 当前选中渠道的档位列表（按 sort 升序）
    skuList() {
      if (!this.selectedChannel || !this.selectedChannel.list) return [];
      return [...this.selectedChannel.list].sort((a, b) => a.sort - b.sort);
    },
    // 自定义金额档位（id 为 0 的特殊档位）
    customSkuItem() {
      return this.skuList.find((i) => i.id === 0);
    },
    // 渠道 logo
    channelLogo() {
      return this.getChannelLogo(this.selectedChannel);
    },
    // 渠道手续费文案
    channelFeeText() {
      return this.getChannelFeeText(this.selectedChannel);
    },
    // 是否为 PIX 渠道（决定货币图标与提现类型）
    isPixChannel() {
      return PIX_CHANNEL_IDS.includes(this.selectedChannelId);
    },
    // 档位货币图标：PIX 用专属图标，其余用 $
    skuCoinIcon() {
      return require("@/assets/withdrawal_v2/$.png")
      // return this.isPixChannel
      //   ? require("@/assets/h5/95a1eb22-e449-4d6a-9643-dd86329ef1b5.png")
      //   : require("@/assets/withdrawal_v2/$.png");
    },
    // 可提现余额的千分位展示文本
    coinText() {
      return Number(this.coin || 0).toLocaleString("en-US");
    },
    // 自定义金额是否可提交：输入>0 且无错误且到账额>0
    canSubmitCustom() {
      return (
        this.getInputNumber() > 0 &&
        this.errorAcual === 0 &&
        this.acualNum > 0
      );
    },
    // 法币到账提示：用 preview 接口返回的法币类型 + 实际到账金额（不再写死示例）
    fiatHintText() {
      if (this.getInputNumber() === 0) return "";
      // preview 接口返回 currency（法币类型）与 acualNum（法币实际到账）
      if (this.currency && this.acualNum > 0) {
        return `≈${this.currency} ${this.formatFiat(this.acualNum)}`;
      }
      return "";
    },
  },
  watch: {
    // 父组件传入余额时同步内部 coin
    parentCoin: {
      handler(val) {
        if (val) this.coin = Number(val);
      },
      immediate: true,
    },
    // 渠道选择器显示时锁定背景滚动，隐藏时恢复；打开时默认选中第一个并滚动到当前选中渠道
    showChannelPicker(val) {
      if (val && !this.showPop) {
        document.body.style.overflow = "hidden";
        // 默认选中第一个渠道（若当前无有效选中）
        if (
          this.selectedChannelId == null ||
          !this.channelList.some((c) => c.id === this.selectedChannelId)
        ) {
          this.selectedChannelId = this.channelList[0]?.id ?? null;
        }
        // 滚动到当前选中的渠道，保持其展示在可视区域内
        this.$nextTick(() => {
          const listEl = this.$refs.channelList;
          const activeEl =
            listEl && listEl.querySelector(".sw-channel-option.active");
          if (listEl && activeEl) {
            const targetTop = activeEl.offsetTop - listEl.offsetTop;
            listEl.scrollTop = Math.max(
              0,
              targetTop - listEl.clientHeight / 2 + activeEl.clientHeight / 2
            );
          }
        });
      } else if (!val && !this.showPop) {
        document.body.style.overflow = "";
      }
    },
  },
  // 初始化：鉴权 + 拉取渠道列表
  created() {
    this.initAuth();
    this.fetchChannels();
  },
  // 销毁前清理防抖定时器并恢复背景滚动
  beforeDestroy() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
    document.body.style.overflow = "";
  },
  methods: {
    // 从 localStorage 初始化鉴权信息；无 token 直接跳过
    initAuth() {
      const ids =
        navigator.userAgent.match(
          /(iPhone|iPod|iPad|Android|BlackBerry|Windows Phone)/
        )?.[0] || "Unknown Device";
      const raw = localStorage.getItem("data");
      if (!raw) return;
      try {
        const data = JSON.parse(raw);
        if (!data?.token) return;
        this.token = data.token;
        this.uid = String(data.uid ?? data.userId ?? "");
        this.lang = data.lang || navigator.language;
        this.deviceId = String(data.deviceId || ids);
      } catch (e) {
        /* ignore */
      }
    },
    // 过滤出可提现的渠道：标准渠道或 PIX 渠道
    getWithdrawChannels(items = []) {
      return items.filter(
        (item) =>
          STANDARD_CHANNEL_IDS.includes(item.id) ||
          PIX_CHANNEL_IDS.includes(item.id)
      );
    },
    // 渠道 logo（当前固定使用默认 logo）
    getChannelLogo(item) {
      return item.icon;
    },
    // 组装渠道手续费文案：优先接口 feeDesc，其次 feeTips/handlingFee/区间
    getChannelFeeText(item) {
      if (!item) return "";
      // 手续费字段：getInfoForWeb 返回渠道顶层 fee（如 "1-10%"），优先展示
      if (item.fee) return item.fee;
      if (item.feeDesc) return item.feeDesc;
      if (item.feeTips) return item.feeTips;
      if (item.handlingFee) return item.handlingFee;
      if (item.feeMin != null && item.feeMax != null) {
        return `$${item.feeMin}-$${item.feeMax}`;
      }
      if (item.id === 17) return this.$t("guild_page_fee");
      return item.tips || "";
    },
    // 解析默认选中渠道：优先本地缓存，其次接口默认，最后取第一个
    resolveDefaultChannelId(channels) {
      const saved = localStorage.getItem(CHANNEL_STORAGE_KEY);
      if (saved && channels.some((c) => String(c.id) === saved)) {
        return Number(saved);
      }
      const data = this.listData || {};
      const defaultId =
        data.defaultChannelId ?? data.defaultItemId ?? data.recommendChannelId;
      if (defaultId && channels.some((c) => c.id === defaultId)) {
        return defaultId;
      }
      return channels[0]?.id ?? null;
    },
    // 拉取渠道列表并回填余额、确定默认渠道
    fetchChannels() {
      if (!this.token) {
        this.loading = false;
        return;
      }
      axios
        .get(
          this.$serviceIp +
            `api/trade/card/tx/getInfoForWeb?token=${this.token}&uid=${this.uid}`,
          { headers: { deviceId: this.deviceId, lang: this.lang } }
        )
        .then((response) => {
          if (response.data.code !== 200) {
            Toast(response.data.message || this.$t("transfer.error"));
            return;
          }
          this.listData = response.data.data || {};
          // 父组件未传入余额时，用接口的 cin 作为可提现余额
          if (this.listData.cin != null && !this.parentCoin) {
            this.coin = Number(this.listData.cin);
          }
          const channels = this.getWithdrawChannels(this.listData.item || []);
          // 每个渠道的 SKU 按 sort 升序排列
          channels.forEach((el) => {
            if (el.list) el.list.sort((a, b) => a.sort - b.sort);
          });
          this.channelList = channels;
          this.selectedChannelId = this.resolveDefaultChannelId(channels);
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    // 选择渠道：更新选中 id、写入本地缓存并关闭选择器
    selectChannel(item) {
      this.selectedChannelId = item.id;
      localStorage.setItem(CHANNEL_STORAGE_KEY, String(item.id));
      this.showChannelPicker = false;
    },
    // 点击固定档位 SKU：余额不足提示，否则走统一提现流程
    onSkuClick(Aitem) {
      if (Number(this.coin) < Number(Aitem.USD)) {
        this.showBalanceTip = true;
        return;
      }
      // 固定档位：统一走新流程（绑定半层 → 确认页）
      this.proceedWithdraw(this.selectedChannel, Aitem);
    },
    // 打开自定义金额弹窗：初始化上下文与输入状态
    openCustomAmount() {
      const item = this.selectedChannel;
      const Aitem = this.customSkuItem;
      if (!item || !Aitem) return;
      this.showPop = true;
      this.customizeItem = item;
      this.customizeAitem = { ...Aitem };
      this.payType = this.isPixChannel ? 2 : 1;
      this.inputValue = "";
      this.acualNum = 0;
      this.currency = "";
      this.errorAcual = 0;
      this.gearType = 5;
      document.body.style.overflow = "hidden";
      this.$nextTick(() => this.inputFocus());
    },
    // 关闭自定义金额弹窗：重置状态并恢复背景滚动
    closePopup() {
      this.showPop = false;
      this.keyboardShow = false;
      this.inputValue = "";
      this.acualNum = 0;
      this.currency = "";
      this.errorAcual = 0;
      this.gearType = 5;
      if (!this.showChannelPicker) {
        document.body.style.overflow = "";
      }
    },
    // 法币金额千分位格式化
    formatFiat(val) {
      return Number(val || 0).toLocaleString("en-US");
    },
    // 输入金额千分位格式化
    formatInputValue(raw) {
      if (!raw) return "";
      return Number(raw).toLocaleString("en-US");
    },
    // 去掉千分位逗号取实际数值
    getInputNumber() {
return Number(String(this.inputValue).replace(/,/g, "")) || 0;
    },
    // 快捷档位：全部 / 1/2 / 1/3 / 1/4，再次点击取消
    changeGearType(type) {
      if (this.gearType === type) {
        this.gearType = 5;
        this.inputValue = "";
      } else {
        this.gearType = type;
        const ratios = [1, 2, 3, 4];
        const ratio = ratios[type] || 1;
        this.inputValue = this.formatInputValue(String(Math.floor(this.coin / ratio)));
      }
      this.changeCoin();
    },
    // 校验输入是否超过可提现余额，超过则标记 errorAcual=3
    inputValueLegal() {
      if (this.getInputNumber() > Number(this.coin)) {
        this.errorAcual = 3;
      } else if (this.errorAcual === 3) {
        this.errorAcual = 0;
      }
    },
    // 输入变化：清洗非法字符、格式化，并按文本长度自适应输入框宽度
    changeCoin() {
      const raw =
        this.inputValue.toString().replace(/[^\d]/g, "").replace(/^0+/, "") || "";
      this.inputValue = this.formatInputValue(raw);
      this.inputValueLegal();
      this.$nextTick(() => {
        const span = this.$refs.measureRef;
        const input = this.$refs.inputRef;
        if (span && input) {
          let width = span.offsetWidth + 20;
          if (raw.length > 5) width += 20;
          if (raw.length > 9) width += 20;
          input.style.width = Math.max(width, 40) + "px";
          const len = this.inputValue.length;
          input.setSelectionRange(len, len);
        }
        this.changeAcualNum();
      });
    },
    // 计算实际到账金额：防抖 500ms 后请求 preview 接口
    changeAcualNum() {
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      this.acualNum = 0;
      if (this.getInputNumber() === 0) {
        this.errorAcual = this.errorAcual === 3 ? 3 : 0;
        return;
      }
      if (this.errorAcual !== 3) this.errorAcual = 0;
      this.debounceTimer = setTimeout(() => this.fetchAcualNum(), 500);
    },
    // 请求实际到账金额：校验最小/最大/余额上限
    fetchAcualNum() {
      axios({
        url: this.$serviceIp + "api/trade/card/tx/preview",
        method: "post",
        headers: {
          deviceId: this.deviceId,
          version: "3.0",
          lang: this.lang,
        },
        data: {
          cid: this.customizeAitem.channel,
          pocketCoin: this.getInputNumber(),
        },
        params: { token: this.token, uid: this.uid },
      }).then((res) => {
        if (res.data.code !== 200) {
          Toast(res.data.message || this.$t("transfer.error"));
          return;
        }
        const d = res.data.data || {};
        let finalAmount = d.finalAmount > 0 ? d.finalAmount : 0;
        // 低于最小到账额
        if (Number(finalAmount) < Number(d.minUsd)) {
          this.errorAcual = 1;
          this.acualNum = 0;
          return;
        }
        // 超过最大到账额
        if (Number(finalAmount) > Number(d.maxUsd)) {
          this.errorAcual = 2;
          this.acualNum = 0;
          return;
        }
        // 超过可提现余额
        if (this.getInputNumber() > Number(this.coin)) {
          this.errorAcual = 3;
          this.acualNum = 0;
          return;
        }
        this.errorAcual = 0;
        this.acualNum = finalAmount;
        this.currency = d.currency;
      });
    },
    // 输入框聚焦：重置档位、光标置末
    inputFocus() {
      this.gearType = 5;
      this.keyboardShow = true;
      const input = this.$refs.inputRef;
      if (!input) return;
      if (this.getInputNumber() === 0) this.inputValue = "";
      this.$nextTick(() => {
        input.focus();
        const len = input.value.length;
        input.setSelectionRange(len, len);
      });
    },
    // 失焦：隐藏键盘状态
    handleBlur() {
      this.keyboardShow = false;
    },
    // 提交自定义提现：组装 Aitem 后走统一提现流程
    submitPay() {
      if (!this.canSubmitCustom) {
        if (this.errorAcual === 1) {
          Toast(this.$t("withdraw_error_min_amount"));
        }
        return;
      }
      // 组装自定义档位 Aitem：
      //   USD 为提现 P 币数（接口档位标准字段，大写），num 为法币到账金额，cc 为法币类型
      const Aitem = {
        ...this.customizeAitem,
        cc: this.customizeAitem.currency,
        num: this.acualNum,
        USD: this.getInputNumber(),
      };
      this.closePopup();
      if (Number(this.coin) < Aitem.USD) {
        this.showBalanceTip = true;
        return;
      }
      this.proceedWithdraw(this.customizeItem, Aitem);
    },
  },
};
</script>

<style scoped>
.sw-panel {
  /* padding: 0 28px 48px; */
  font-family: "Montserrat";
}

.sw-loading {
  display: flex;
  justify-content: center;
  padding: 80px 0;
}

.sw-channel-card {
  display: flex;
  align-items: center;
  width: 584px;
  height: 116px;
  gap: 16px;
  padding: 24px;
  background: #fff;
  border-radius: 24px;
  box-sizing: border-box;
  margin: 0 auto;
}

.sw-channel-logo {
  width: 120px;
  height: 68px;
  border-radius: 12px;
  object-fit: contain;
  background: #f5f6f8;
  flex-shrink: 0;
}

.sw-channel-info {
  flex: 1;
  min-width: 0;
}

.sw-channel-name {
  margin: 0 0 8px;
  font-size: 28px;
  font-weight: 700;
  color: #121212;
}

.sw-channel-fee {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  color: #89848d;
}

.sw-change-btn {
  flex-shrink: 0;
  height: 56px;
  padding: 0 24px;
  border: none;
  border-radius: 28px;
  background: rgba(123, 77, 255, 0.12);
  color: #7b4dff;
  font-size: 24px;
  font-weight: 600;
  font-family: inherit;
}
.sw-balance-parent {
  width: 100%;
  background-color: #fff;
  height: calc(100vh - 228px - env(safe-area-inset-top));
  height: calc(100vh - 228px - constant(safe-area-inset-top));
  box-sizing: border-box;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 24px;
  border-radius: 24px 24px 0 0;
  padding: 32px;
}

.sw-balance {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 24px;
  color: #262427;
  font-weight: 400;
  margin-bottom: 28px;
}

.sw-balance-num {
  display: inline-flex;
  align-items: center;
  font-size: 32px;
  font-weight: 700;
  color: #262427;
}

.sw-balance-num::before {
  content: "";
  width: 36px;
  height: 36px;
  margin-right: 4px;
  background: url("../../assets/withdrawal_v2/$.png") no-repeat center;
  background-size: contain;
}

.sw-section-title {
  margin: 0 0 16px;
  font-size: 24px;
  font-weight: 500;
  color: #89848D;
}

.sw-sku-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.sw-sku-item {
  width: calc((100% - 40px) / 3);
  min-height: 128px;
  padding: 20px 12px;
  box-sizing: border-box;
  border-radius: 24px;
  border: 1px solid #e8ecf0;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.sw-sku-fiat {
  font-size: 30px;
  font-weight: 700;
  color: #121212;
  text-align: center;
  word-break: break-word;
}

.sw-sku-coin {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 24px;
  font-weight: 500;
  color: #89848d;
}

.sw-sku-coin img {
  width: 28px;
  height: 28px;
}

.sw-sku-custom {
  font-size: 24px;
  font-weight: 500;
  color: #262427;
  flex-direction: row;
}

.sw-sku-custom::after {
  content: "";
  width: 24px;
  height: 24px;
  margin-left: 4px;
  background: url("../../assets/withdrawal_v2/back.png") no-repeat center;
  background-size: contain;
  transform: scaleX(-1);
}

.sw-mask {
  position: fixed;
  inset: 0;
  z-index: 200;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.sw-mask-center {
  align-items: center;
  padding: 0 48px;
  box-sizing: border-box;
}

.sw-channel-picker-mask {
  position: fixed;
  inset: 0;
  z-index: 200;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  overflow: hidden;
}

.sw-picker-enter-active,
.sw-picker-leave-active {
  transition: opacity 0.28s ease;
}

.sw-picker-enter-active .sw-channel-sheet,
.sw-picker-leave-active .sw-channel-sheet {
  transition: transform 0.32s cubic-bezier(0.32, 0.72, 0, 1);
}

.sw-picker-enter,
.sw-picker-leave-to {
  opacity: 0;
}

.sw-picker-enter .sw-channel-sheet,
.sw-picker-leave-to .sw-channel-sheet {
  transform: translateY(100%);
}

.sw-channel-sheet {
  width: 100%;
  max-height: 50vh;
  background: #fff;
  border-radius: 24px 24px 0 0;
  padding: 0 24px;
  box-sizing: border-box;
  transform: translateY(0);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sw-sheet-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 96px;
  flex-shrink: 0;
  background: #fff;
  z-index: 1;
}

.sw-sheet-close {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  padding: 4px;
  box-sizing: border-box;
}

.sw-sheet-title {
  margin: 0;
  font-size: 26px;
  font-weight: 600;
  text-align: center;
  color: #121212;
}

.sw-channel-list {
  max-height: calc(50vh - 96px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: calc(24px + env(safe-area-inset-bottom));
  padding-bottom: calc(24px + constant(safe-area-inset-bottom));
}

.sw-channel-option {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 20px;
  margin-bottom: 16px;
  border-radius: 24px;
  background: transparent;
}

.sw-channel-option:last-child {
  margin-bottom: 0;
}

.sw-channel-option.active {
  background: #f3f4f6;
}

.sw-channel-option-logo-wrap {
  width: 88px;
  height: 64px;
  border-radius: 16px;
  background: #fff;
  border: 1px solid #ececf0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.sw-channel-option.active .sw-channel-option-logo-wrap {
  border-color: #e4e4e8;
}

.sw-channel-option-logo {
  width: 72px;
  height: 48px;
  object-fit: contain;
}

.sw-channel-option-info {
  flex: 1;
  min-width: 0;
}

.sw-channel-option-name {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 24px;
  font-weight: 600;
  color: #121212;
  /* margin-bottom: 8px; */
  /* line-height: 1.2; */
}

.sw-edit-icon {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
}

.sw-channel-option-fee {
  display: block;
  font-size: 22px;
  line-height: 32px;
  color: #89848d;
}

.sw-radio-icon {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}

.sw-amount-dialog {
  position: relative;
  width: 592px;
  margin: auto;
  background: #fff;
  border-radius: 24px;
  padding: 60px 32px 32px;
  box-sizing: border-box;
  transition: transform 0.3s ease;
}

.sw-amount-dialog.keyboard-active {
  transform: translateY(-80px);
}

.sw-dialog-close {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 28px;
  height: 28px;
  cursor: pointer;
}

.sw-dialog-close::before,
.sw-dialog-close::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 2px;
  background: #121212;
}

.sw-dialog-close::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.sw-dialog-close::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.sw-dialog-title {
  margin: 0 0 32px;
  font-size: 28px;
  font-weight: 500;
  text-align: center;
  color: #1F1315;
}

.sw-input-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 528px;
  height: 88px;
  padding: 0 24px;
  border: 1px solid #dbdbdb;
  border-radius: 24px;
  background: #fff;
  box-sizing: border-box;
}

.sw-input-left {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.sw-input-left > img {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  margin-right: 8px;
}

.sw-measure {
  position: absolute;
  visibility: hidden;
  white-space: pre;
  font-size: 32px;
  font-family: "Mada", sans-serif;
}

.sw-input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 28px;
  font-weight: 700;
  color: #262427;
  width: 40px;
  min-width: 40px;
  padding: 0;
}

.sw-fiat-hint {
  flex-shrink: 0;
  margin-left: 12px;
  font-size: 24px;
  font-weight: 400;
  color: #89848d;
  white-space: nowrap;
}

.sw-balance-hint {
  display: flex;
  align-items: center;
  margin: 26px 0 10px;
  font-size: 24px;
  font-weight: 400;
  color: #262427;
}

.sw-balance-hint img {
  width: 36px;
  height: 36px;
  margin: 0 4px;
}

.sw-balance-hint span {
  font-size: 26px;
}

.sw-gear-box {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 0 0 32px;
  list-style: none;
}

.sw-gear-box li {
  flex: 1;
  height: 64px;
  line-height: 64px;
  text-align: center;
  border: 1px solid #dfd9e3;
  border-radius: 32px;
  font-size: 24px;
  font-weight: 400;
  color: #89848d;
}

.sw-gear-box li.active {
  color: #8131E7;
  border-color: #8131E7;
}

.sw-error-tip {
  margin: 0 0 16px;
  font-size: 24px;
  color: #f46363;
  text-align: center;
}

.sw-submit-btn {
  display: block;
  width: 412px;
  height: 80px;
  border: none;
  border-radius: 44px;
  background: #8131E7;
  font-size: 24px;
  font-weight: 500;
  color: #fff;
  font-family: inherit;
  margin: 0 auto;
}

.sw-submit-btn.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.sw-balance-popup {
  padding: 32px 48px;
  font-size: 28px;
  text-align: center;
}

.hide-scrollbar {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

html[lang="ar"] .sw-panel {
  direction: rtl;
}

html[lang="ar"] .sw-sku-custom::after {
  margin-left: 0;
  margin-right: 4px;
  transform: scaleX(1);
}
</style>
